
<template>
    
    <div class="wrap">

        <div class="content">
            <swiper class="swiper" :options="swiperOptions">


                <swiper-slide class="swiper-item">
                        
                        <scroller class="scroll">
                            <div class="text">
                                <img :src="obj.pubBomSelectResVO.picList[0].url" alt="">
                                <div class="details">
                                    <div class="details-item d_f">
                                        <i></i>
                                        <div class="item-text" v-if="obj.pubBomSelectResVO">
                                            <h2>产品资料</h2>
                                            <p><label>设备名称：</label><span>{{obj.pubBomSelectResVO.name}}</span></p>
                                            <p><label>材料名称：</label><span>{{obj.pubBomSelectResVO.keyMaterialName}}</span></p>
                                            <p><label>材料指标：</label><span>{{obj.pubBomSelectResVO.keyMaterialKdj}}</span></p>
                                            <p><label>材料品牌：</label><span>{{obj.pubBomSelectResVO.keyMaterialBrand}}</span></p>
                                            <p><label>生产日期：</label><span>{{obj.pubBomSelectResVO.productDate}}</span></p>
                                            <p><label>出厂日期：</label><span>{{obj.pubBomSelectResVO.packingDate}}</span></p>
                                            <p><label>质保期：</label><span>{{obj.pubBomSelectResVO.warrantyDate}}年</span></p>
                                        </div>
                                    </div>
                                    <div class="details-item d_f" v-if="obj.projectEntity">
                                        <i></i>
                                        <div class="item-text">
                                            <h2>项目信息</h2>
                                            <p class="d_f"><label>项目名称：</label><span>{{obj.projectEntity.projectName || '--'}}</span></p>
                                            <p class="d_f"><label>项目负责人：</label><span>{{obj.projectEntity.projectLeader || '--'}}</span></p>
                                            <p class="d_f"><label>项目地址：</label><span>{{obj.projectEntity.projectAddress || '--'}}</span></p>
                                            <p class="d_f"><label>项目开始时间：</label><span>{{obj.projectEntity.projectStartTime || '--'}}</span></p>
                                            <p class="d_f"><label>项目开始时间：</label><span>{{obj.projectEntity.projectEndTime || '--'}}</span></p>
                                        </div>
                                    </div>
                                    <div class="details-item d_f">
                                        <i></i>
                                        <div class="item-text">
                                            <h2>生产厂家</h2>
                                            <p class="d_f"><label>名称：</label><span>{{obj.supplierEntity.supplierName}}</span></p>
                                            <p class="d_f"><label>电话：</label><span>{{obj.supplierEntity.supplierTel}}</span></p>
                                            <p class="d_f"><label>地址：</label><span>{{obj.supplierEntity.supplierAddress}}</span></p>
                                        </div>
                                    </div>
                                    <div class="target">
                                        <router-link to='/home'>前往官网 ></router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="fill">
                                填充物 
                                注 : 此盒子不会显示，原因是因为scroller模块在手机上显示的时候会出现滑动不到底部
                            </div>
                        </scroller>

                </swiper-slide>


                <swiper-slide class="swiper-item">
                        
                        <div class="qualifications">
                            <h2>公司资质</h2>

                            <div class="qualifications-items">
                                <scroller class="scroll">
                                    <img v-for="item in quali" :key="item.id" :src="item.photoUrl" class="item" alt="">
                                    <div class="fill">
                                        填充物 
                                        注 : 此盒子不会显示，原因是因为scroller模块在手机上显示的时候会出现滑动不到底部
                                    </div>
                                </scroller>
                            </div>

                        </div>
                        
                </swiper-slide>
            </swiper>
        </div>

    </div>



</template>


<script>

import index from './index'
export default {
    ...index
}
</script>


<style lang='scss' scoped>

    .wrap{
        width: 100%;
        height: 100vh;
        background:url('../../assets/sm-bg.png') no-repeat center;
        background-size: 100% 100%;
        overflow: hidden;
        .content{
            width: 100%;
            height:100%;
            background-color: rgba(0, 112, 213, .7);
            .swiper{
                height: 100%;
                .swiper-item{
                    height: 100%;
                    .text{
                        position: relative;
                        padding: 5.319vw;
                        // height: 100vh;
                        img{
                            position: absolute;
                            width: 31.915vw;
                            height: 26.596vw;
                            left: 50%;
                            transform: translateX(-50%);
                        }
                        .details{
                            width: 100%;
                            color: #fff;
                            margin-top: 13.298vw;
                            padding-top: 26.596vw;
                            padding-bottom: 7.979vw;
                            background-color: rgba(255, 255, 255, .3);
                            border-radius: 2.66vw;
                            .details-item{
                                margin-bottom: 5.319vw;
                                i{
                                    width: 2.66vw;
                                    height: 4.787vw;
                                    background-color: #fff;
                                    margin-right: 5.319vw;
                                }
                                .item-text{
                                    padding-right: 2.66vw;;
                                    h2{
                                        margin-bottom:3.989vw;
                                        color:#fff;
                                        line-height: 1;
                                        font-size: 6vw !important;
                                    }
                                    p{
                                        font-size: 4vw !important;
                                        span{
                                            flex:1;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .qualifications{
                        padding:5.319vw;
                        height: 100%;
                        box-sizing: border-box;;
                        h2{
                            text-align: center;
                            color: #fff;
                            font-size: 8.968vw;
                            letter-spacing: 2.66vw;
                            font-weight: bold;
                            line-height: 15.957vw;
                            margin-bottom: 2.66vw;
                        }
                        .qualifications-items{
                            position: relative;
                            width: 100%;
                            height: calc(100vh - 29.255vw);
                            .scroll{
                                width: 100%;
                                .item{
                                    display: block;
                                    width: 100%;
                                    margin-bottom: 5.319vw;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .fill{
        height: 26.596vw;
        width: 100%;
        opacity: 0;
    }
    .target{
        text-align: center;
        a{
            color: #fff;
            font-size: 6.383vw;
        }
    }


</style>